export const SET_MOVEMENTS = 'SET_MOVEMENTS';
export const DELETE_MOVEMENTS = 'DELETE_MOVEMENTS';
export const DELETE_ALL_MOVEMENTS = 'DELETE_ALL_MOVEMENTS';
